import { create } from "zustand";
import AuthService from "../../../../../app/base/services/authentication.service";
import { UserIcon } from "../../../../../app/assets/icons";

export const useAvatarStore = create((set) => ({
   fullName: AuthService?.getFullName(),
   profileImage: UserIcon,
   imageLoading: false,

   setFullName: (name) => set({ fullName: name }),
   setProfileImage: (image) => set({ profileImage: image }),
   setImageLoading: (loading) => set({ imageLoading: loading })
}));
